var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"color-bar",style:(_vm.cssVars),attrs:{"no-gutters":""}},_vm._l((_vm.showColors),function(color,iColor){return _c('v-col',{key:iColor,staticClass:"color-bar-item",style:({
      background: color.color
    })},[(
        _vm.showLabels.includes(iColor) &&
          color.label != null &&
          color.label != ''
      )?_c('div',{staticClass:"color-bar-item-label"},[_vm._v(" "+_vm._s(color.label)+" ")]):_vm._e()])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }